module.exports = __webpack_public_path__ + "img/kind.59f29149.png";